import { joinSurveyAction } from '../join-survey';
import type { ConnectChannel } from '../types';

/**
 * Static content for the Web channel detail page (`/connect/web`). Same
 * sourcing rule as demographics.ts: copied, not imported, since the source
 * (Data Catalog / EXPLORE_CHANNELS) backs internal-only tooling and this
 * page is visible to every Home user.
 */
export const WEB_CHANNEL: ConnectChannel = {
    name: 'Web',
    icon: 'globe',
    color: '#418363',
    coverage: 'US mobile web',
    freshness: 'Daily',
    since: '2017',
    exploreDaniPrompt: 'What can web browsing data tell me about my consumers?',
    actions: [
        {
            id: 'web-funnels',
            name: 'Trace funnels',
            icon: 'globe',
            summary: 'the path people take from search to your website to a store visit',
            template:
                'Trace the path from search to {brand|my} website to a store visit over {window|the last 12 weeks}',
        },
        {
            id: 'web-searches',
            name: 'Read searches',
            icon: 'search',
            summary: 'what people search for before they visit your website',
            template:
                'What are consumers searching for before they visit {brand|my} website, over {window|the last 12 weeks}?',
        },
        {
            id: 'web-content',
            name: 'Track content',
            icon: 'book-open',
            summary: "which kinds of content keep your website's visitors engaged longest",
            template:
                'Which content categories keep visitors to {brand|my} website engaged longest?',
        },
        joinSurveyAction('web'),
    ],
    schema: [
        { field: 'consumer_id', type: 'string', description: 'Pseudonymous panel ID' },
        { field: 'domain', type: 'string', description: 'Website domain' },
        { field: 'domain_category', type: 'string', description: 'IAB-style category' },
        { field: 'os', type: 'string', description: 'iOS / Android' },
        { field: 'session_date', type: 'date', description: 'Session date' },
        { field: 'total_minutes', type: 'float', description: 'Session length' },
    ],
    sampleCols: ['Domain', 'Category', 'OS', 'Date', 'Minutes'],
    sampleColWidths: ['minmax(110px, 1.5fr)', 'minmax(90px, 1fr)', '70px', '90px', '70px'],
    sampleRows: [
        ['cnn.com', 'News', 'iOS', '2026-04-02', '3.4 min'],
        ['amazon.com', 'Shopping', 'Android', '2026-04-02', '6.1 min'],
        ['reddit.com', 'Social', 'iOS', '2026-04-03', '12.8 min'],
        ['espn.com', 'Sports', 'Android', '2026-04-03', '4.9 min'],
        ['weather.com', 'Utilities', 'iOS', '2026-04-04', '0.7 min'],
    ],
};
